import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";
import Moment from "moment";



// components
import DailyTranslationCountFilters from "./_filters";
import {CardChartBar} from "../../../components/charts/ChartBar";
import {appHeader} from "../../../util/CartTools";

// labels
import {LIST} from "../../../components/i18n/i18n";

// actions
import { setFilter, setTableParams, setForm, setItem } from "../../../redux/actions/generics/IndexedActions";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";

// services
import {dailyTranslationCountService} from "../../../jwt/_services/xooka/dailyTranslationCountService";

// utils
import {getStateByPath} from "../../../redux/selectors";
import {getFirstDayOfMonth, getLastDayOfMonth} from "../../../util/DateTools";





const DailyTranslationCountList = (props) => {
    const date = new Date()

    const {path} = props
    const componentState = useSelector(state => getStateByPath(state, path));
    const {pageSize, pageIndex, listDomainObjects:data, filter} = componentState?.data || {};

    const [graphicData, setGraphicData] = useState(null)

    useEffect( () => {
        if(filter)
            return

        props.setFilter(path, {
            item: {
                startDate: Moment(getFirstDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD'),
                endDate: Moment(getLastDayOfMonth(date.getFullYear(), date.getMonth())).format('YYYY-MM-DD')
            }
        })
    }, []);


    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, dailyTranslationCountService, pageIndex, pageSize, filter)
    }, [filter]);


    useEffect(() => {

        if(!data)
            return

        const processedData = getGraphicData(data)
        setGraphicData(processedData)

    }, [data]);
    
    const getGraphicData = data => {
        const labels = data.map( item => item.date )
        const datasets = [
            {
                label: 'App Hotel Casa de la Playa',
                data: data.map( item => item?.HCDP > 0 ? item?.HCDP : null),
                backgroundColor: '#FF6384',
                borderColor: '#FF6384',
                borderWidth: 1
            },
            {
                label: 'App hoteles Xcaret',
                data: data.map( item => item?.HOTEL > 0 ? item?.HOTEL : null),
                backgroundColor: '#36A2EB',
                borderColor: '#36A2EB',
                borderWidth: 1
            },
            {
                label: 'App ferries',
                data: data.map( item => item?.FERRY > 0 ? item?.FERRY : null),
                backgroundColor: '#FFCE56',
                borderColor: '#FFCE56',
                borderWidth: 1
            },
            {
                label: 'App Eventos',
                data: data.map( item => item?.EVENTS > 0 ? item?.EVENTS : null),
                backgroundColor: '#8eff56',
                borderColor: '#8eff56',
                borderWidth: 1
            },
            {
                label: 'App Landing',
                data: data.map( item => item?.APPLANDING > 0 ? item?.APPLANDING : null),
                backgroundColor: 'rgba(255,101,101,0.89)',
                borderColor: 'rgba(255,101,101,0.89)',
                borderWidth: 1
            }
        ]

        return {labels, datasets}
    }



    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
        </CardTitle>

        <DailyTranslationCountFilters path={path}/>

        <CardBody>
            {
                graphicData && <CardChartBar
                    title={'Daily Translation Count'}
                    rawData={data}
                    headers={appHeader}
                    graphicData={graphicData}

                />
            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setForm,
    setItem,
})

export default connect(mapStateToProps, mapActionsToProps)(DailyTranslationCountList);